/* eslint-disable max-len */
import React from "react"

const UserFilled = (props) => {
  return (
    <svg {...props} width="24" height="26" viewBox="0 0 24 26" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.28092 7.86823C6.28092 11.0169 8.84798 13.5695 12.0146 13.5695C13.5353 13.5695 14.9937 12.9688 16.0689 11.8996C17.1442 10.8304 17.7483 9.38029 17.7483 7.86823C17.7483 4.71952 15.1812 2.16699 12.0146 2.16699C8.84798 2.16699 6.28092 4.71952 6.28092 7.86823ZM3.97076 23.8318H20.0251C20.2606 23.8507 20.4837 23.724 20.587 23.5126L21.9401 20.8444C22.0563 20.6118 21.9997 20.3305 21.8025 20.1602C18.2361 17.0245 14.5666 15.622 10.9085 15.8843C7.54884 16.2098 4.42672 17.7519 2.13598 20.2172C1.99003 20.3935 1.95881 20.6374 2.05571 20.8444L3.45473 23.5126C3.5512 23.7083 3.75151 23.8323 3.97076 23.8318Z"
        fill="#21295C"
      />
    </svg>
  )
}

export default UserFilled
